import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { ChartSpecification } from '../../../../dataModels/chart-data-model';

declare var AmCharts;

@Component({
    selector: 'ring-chart',
    templateUrl: 'ring-chart.component.html',
    styleUrls: ['ring-chart.component.css', '../../charts.style.scss']
})

export class RingChartComponent implements OnInit, AfterViewInit {

    @Input() chartSpecification: ChartSpecification;

    constructor() { }

    ngOnInit() {
        this.chartSpecification.title = this.chartSpecification.title || "";
        this.chartSpecification.theme = this.chartSpecification.theme || "none";
        this.chartSpecification.chartColor = this.chartSpecification.chartColor || "";
        this.chartSpecification.data = this.chartSpecification.data || [];
        this.chartSpecification.yAxisTitle = this.chartSpecification.yAxisTitle || "";
        this.chartSpecification.xAxis = this.chartSpecification.xAxis || "xAxis";
        this.chartSpecification.yAxis = this.chartSpecification.yAxis || "yAxis";
        this.chartSpecification.divId = this.chartSpecification.divId || "multiDiv";
        this.chartSpecification.graphs = this.chartSpecification.graphs || [];
        this.chartSpecification.valueAxes = this.chartSpecification.valueAxes || [];
    }

    ngAfterViewInit() {
        this.drawChart();
    }

    drawChart() {
        setTimeout(() => {

            let chartSettings = this.getChartSettings();

            AmCharts.makeChart(this.chartSpecification.divId, {
                "hideCredits": true,
                "type": "gauge",
                "theme": this.chartSpecification.theme,
                "titles": [{
                    "size": 12,
                    "text": this.chartSpecification.title
                }],
                "axes": [{
                    "axisAlpha": 0,
                    "tickAlpha": 0,
                    "labelsEnabled": false,
                    "startValue": 0,
                    "endValue": 100,
                    "startAngle": 0,
                    "endAngle": 360,
                    "bands": chartSettings.bands
                }],
                "allLabels": chartSettings.labels,
                "export": {
                    "enabled": true,
                    "fileName": this.chartSpecification.title
                }
            });
        }, 20);
    }

    getChartSettings() {
        let bands: any[] = [];
        let labels: any[] = []

        let length = this.chartSpecification.graphs.length;
        let data = this.chartSpecification.data;

        this.chartSpecification.graphs.forEach((item, index) => {
            bands.push({
                "color": "#eee",
                "startValue": 0,
                "endValue": 100,
                "radius":  "85%",
                "innerRadius": "100%"
            });

            bands.push({
                "color": item.color,
                "startValue": data[index][this.chartSpecification.xAxis],
                "endValue": data[index][this.chartSpecification.yAxis],
                "radius": "85%",
                "innerRadius": "100%",
                "balloonText": data[index][this.chartSpecification.yAxis] + "%"
            });

            labels.push({
                "text": item.title,
                "x": "50%",
                "y": "55%",
                "size": 18,
                "bold": true,
                "color": item.color,
                "align": "middle"
            });
        });

        

        return { bands, labels };
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/gaugeCharts/ringChart/ring-chart.component.ts